export type LineIds = number[]
export const formatGroupAcceptedLineIds = (groupSelectedLineIds?: LineIds) => {
  if (groupSelectedLineIds === undefined) return undefined

  return groupSelectedLineIds.map(lineId => ({ product: lineId }))
}
